const InitialState = {
  isCollapse: false,
  isMobile: false,
  isShowingTotals: false,
  isDark: false,
};

const mutations = {
  update(state, isCollapse) {
    return Object.assign(state, { isCollapse });
  },
  isMobile(oldState, isMobile) {
    return Object.assign(oldState, { isMobile });
  },
  stateTotals(oldState, isShowingTotals) {
    return Object.assign(oldState, { isShowingTotals });
  },
  setDark(state, isDark) {
    return Object.assign(state, { isDark });
  },
};

const getters = {
  layout: (state) => state,
};

export default {
  state: InitialState,
  mutations,
  getters,
  namespaced: true,
};
